module.exports = __webpack_public_path__ + "static/img/gzfx-title.332622b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/xiayan/assets/img/gzfx-title.png
// module id = Mc3q
// module chunks = 1